import { __assign } from 'tslib';
import 'reflect-metadata';
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @param {?=} params
 * @return {?}
 */

function DestroySubscribers(params) {
  return function (target) {
    params = __assign({
      destroyFunc: 'ngOnDestroy'
    }, params);
    /** @type {?} */

    var unsubscribableLike = {
      subscriptions: [],
      unsubscribe: unsubscribe
    };
    /** @type {?} */

    var subscriber = Reflect.getMetadata('subscription:name', target.prototype, 'subscriber');
    Object.defineProperty(target.prototype, subscriber || 'subscriber', {
      get: function () {
        return {
          unsubscribe: unsubscribe.bind(this)
        };
      },
      set: function (subscription) {
        unsubscribableLike.subscriptions.push({
          subscription: subscription,
          instance: this
        });
      }
    });

    if (typeof target.prototype[params.destroyFunc] !== 'function') {
      throw new Error(target.prototype.constructor.name + " must implement " + params.destroyFunc + "() lifecycle hook");
    }

    target.prototype[params.destroyFunc] = ngOnDestroyDecorator(target.prototype[params.destroyFunc]);
    /**
     * @param {?} f
     * @return {?}
     */

    function ngOnDestroyDecorator(f) {
      return function () {
        unsubscribe.call(this);
        return f.apply(this, arguments);
      };
    }
    /**
     * @return {?}
     */


    function unsubscribe() {
      var _this = this;
      /** @type {?} */


      var subscriptions = unsubscribableLike.subscriptions.filter(function (sub) {
        return sub && typeof sub.subscription.unsubscribe === 'function';
      });
      /** @type {?} */

      var componentInstanceSubscriptions = subscriptions.filter(function (sub) {
        return sub.instance === _this;
      });
      componentInstanceSubscriptions.forEach(function (_a) {
        var subscription = _a.subscription;
        return subscription.unsubscribe();
      });
    }

    return target;
  };
}
/**
 * @param {?=} params
 * @return {?}
 */


function CombineSubscriptions(params) {
  return function (target, propertyKey) {
    Reflect.defineMetadata('subscription:name', propertyKey, target, 'subscriber');
  };
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */


export { DestroySubscribers, CombineSubscriptions };